import { createAction, props } from '@ngrx/store'
import { ISeguridad } from '@shared/interfaces/app.state.interfaces'

export const seguridad = createAction(
    '[Seguridad] Token',
    props<{ item: ISeguridad }>()

)